import { defineComponent } from 'vue';
import { Product } from '../../services/product';
import { Booking } from '../../services/booking';

const Prod = new Product();
const Book = new Booking();

export default defineComponent({
    name: 'CartPreviewButton',

    data() {
        return {
            showPopover: false,
            hideTimer: null as ReturnType<typeof setTimeout> | null,
        };
    },

    computed: {
        trips(): any[] {
            return this.$store.getters.get_Basket?.trips ?? [];
        },

        cartCount(): number {
            const trips = this.trips;
            if (trips.length === 1 && trips[0].tour_id === '') return 0;
            return trips.length + Book.getTotal_Add_Ons(this.$store.getters.get_Basket);
        },

        hasItems(): boolean {
            return this.cartCount > 0;
        },
    },

    methods: {
        getTourDetails(tour_id: string): any {
            return Prod.Get_Details_Sync(tour_id, this.$store);
        },

        getTourName(tour_id: string): string {
            return this.getTourDetails(tour_id)?.name ?? tour_id;
        },

        getTourImage(tour_id: string): string {
            return this.getTourDetails(tour_id)
                ?.marketing_information?.media?.[0]?.assets?.[0]?.asset_url ?? '';
        },

        isMobile(): boolean {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },

        onMouseEnter() {
            if (this.hideTimer) clearTimeout(this.hideTimer);
            this.showPopover = true;
        },

        onMouseLeave() {
            // Small delay so the user can move from button into popover without flicker
            this.hideTimer = setTimeout(() => {
                this.showPopover = false;
            }, 120);
        },
    },

    unmounted() {
        if (this.hideTimer) clearTimeout(this.hideTimer);
    },
});